<template>
    <ul :class="[rootClass, 'grid-image-with-name', { 'grid-image-with-name--inside': inside}]">
        <ItemGridImageWithName
            v-for="item in list"
            :key="`${rootClass}-${item.id}`"
            v-bind="item"
            :inside="inside"
            :inside-redirect="insideRedirect"
            :root-class="rootClass"
            :class="[itemClassName, 'grid-image-with-name__item']"
        />
    </ul>
</template>

<script>
import ItemGridImageWithName from './components/ItemGridImageWithName';

export default {
    name: 'GridImageWithName',
    components: {
        ItemGridImageWithName,
    },
    inheritAttrs: false,
    props: {
        list: {
            type: Array,
            required: true,
        },
        inside: {
            type: Boolean,
            default: false,
        },
        insideRedirect: {
            type: Boolean,
            default: false,
        },
        rootClass: {
            type: String,
            default: 'grid-image-with-name',
        },
    },
    computed: {
        itemClassName() {
            if (!this.rootClass) {
                return null;
            }
            return `${this.rootClass}__item`;
        },
    },
};
</script>

<style lang="scss">
    .grid-image-with-name {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-flow: row wrap;
        padding: 25px 0 10px 0;

        &__item {
            padding: 10px;
            flex: 0 1 50%;
            text-align: center;
        }

        &__image {
            width: 100%;
        }

        &--inside {
            .grid-image-with-name__item {
                flex: 0 1 100%;
                width: 100%;
                max-width: 300px;
            }

            .grid-image-with-name__image-wrapper {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

    @media (min-width: $mf-breakpoint-tablet) {
        .grid-image-with-name {
            &--inside {
                .grid-image-with-name__item {
                    flex: 0 1 50%;
                }
            }
        }
    }

    @media (min-width: $mf-breakpoint-small-desktop) {
        .grid-image-with-name {
            padding: 35px 0 10px 0;

            &__item {
                flex: 0 1 33.33%;
            }
        }
    }

    @media (min-width: $breakpoint-big-desktop) {
        .grid-image-with-name--inside .grid-image-with-name__item {
            flex: 0 1 25%;
        }
    }
</style>
